import styled from "styled-components";
import tw from "twin.macro";


export const CookieVideoPreferencesWrapper = styled.div`
  ${tw`absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center p-4 text-center text-white`}
  background-color: rgba(0, 0, 0, 0.7);
`

export const CookieVideoPreferencesText = styled.p`
  ${tw`z-10 font-medium`}
`

export const CookieVideoPreferencesButton = styled.button`
  ${tw`z-10 mt-3 px-4 py-2 bg-white text-black rounded-lg text-sm font-semibold`}
`

export const CookieVideoPreferencesImage = styled.img`
  ${tw`absolute top-0 left-0 w-full h-full object-cover`}
  opacity: 0.3;
`